export default {
    // 禁止inpu框输入某文字，文字正则绑定在指令.
    inputexclude: {
        // 当被绑定的元素插入到 DOM 中时……
        bind: function (el, { value, modifiers }) {
            if((el.tagName === 'INPUT' && el.type === 'text') || el.tagName === 'TEXTAREA') {

            } else {
                if (el.querySelector('input[type=text]')) {
                    el = el.querySelector('input[type=text]');
                } else {
                    el = el.querySelector('textarea');
                }

            }
            if(el) {
                el.addEventListener('keyup', () => {
                    el.value = el.value.replace(new RegExp(value, 'ig'), '')
                    el.dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'))
                })

                el.addEventListener('onpaste', () => {
                    el.value = el.value.replace(new RegExp(value, 'ig'), '')
                    el.dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'))
                })

            }

        }
    }
}


// WEBPACK FOOTER //
// ./src/directives/index.js